import { Text } from '@mantine/core';

export type GradientLegendEntry = {
  value: number;
  label: string;
  color: string;
};

interface GradientLegendProps {
  entries: GradientLegendEntry[];
}

export function GradientLegend({ entries }: GradientLegendProps) {
  const sortedEntries = [...entries].sort((a, b) => a.value - b.value);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '150px',
        }}
      >
        {[...sortedEntries]
          .reverse()
          .filter(
            (_, index, array) =>
              index === 0 ||
              index === Math.floor(array.length / 4) ||
              index === Math.floor(array.length / 2) ||
              index === Math.floor((array.length * 3) / 4) ||
              index === array.length - 1,
          )
          .map((entry) => (
            <Text key={entry.value} size="xs" ta="right">
              {entry.label}
            </Text>
          ))}
      </div>
      <div
        style={{
          width: '30px',
          height: '150px',
          background: `linear-gradient(to top, ${sortedEntries
            .map((entry) => entry.color)
            .join(', ')})`,
          borderRadius: '4px',
        }}
      />
    </div>
  );
}

export default GradientLegend;
